import { useAuthUser } from "context/GameAuthContext";
import useGameTutorial from "gameTutorial/hook";
import { Steps } from "intro.js-react";
import "intro.js/introjs.css";
import * as React from "react";
import { useIntl } from "react-intl";

const GameSteps = ({
	organizationName,
	chatBotConfigBotName,
	playingTimeInMillis,
}: {
	organizationName: string;
	chatBotConfigBotName: string;
	playingTimeInMillis: number;
}) => {
	let stepRef = React.useRef<Steps>(null);
	const intl = useIntl();
	const user = useAuthUser();

	const { steps, isLoaded, enabled, onBeforeChange, exit } = useGameTutorial(
		stepRef,
		organizationName,
		chatBotConfigBotName,
		playingTimeInMillis,
	);

	if (!isLoaded || user?.isTestMode) {
		return <></>;
	}

	return (
		<Steps
			enabled={enabled}
			steps={steps}
			initialStep={0}
			onExit={exit}
			onBeforeChange={onBeforeChange}
			options={{
				showBullets: false,
				exitOnOverlayClick: false,
				hidePrev: true,
				nextLabel: intl.formatMessage({ id: "TUTORIAL.button.next" }),
				skipLabel: `<a role="button" data-testid='skip-intro-button'>${intl.formatMessage({
					id: "TUTORIAL.button.skip",
				})}</a>`,
				doneLabel: intl.formatMessage({ id: "TUTORIAL.button.finish" }),
			}}
			ref={stepRef}
		/>
	);
};

export default React.memo(GameSteps);
